import { Landing } from 'features/misc';
import { useAuth } from 'lib/auth';
import { useRoutes } from 'react-router-dom';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const auth = useAuth();

  const commonRoutes = [{ path: '/', element: <Landing /> }];

  const routes = auth.user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};

export const PAGES = {
  finance: 'finance',
  currencies: 'currencies',
  currencyDetails: 'currency_details',
  paymentMethods: 'payment_methods',
  withdrawPaymentMethods: 'withdraw_payment_methods',
  depositPaymentMethods: 'deposit_payment_methods',
  swapPaymentMethods: 'swap_payment_methods',
  transferPaymentMethods: 'tranfer_payment_methods',
};
